import React, {useState} from 'react';
import {Radio} from "antd";
import {t} from "i18next";
import {
    Card,
    ClickableDiv,
    FlexColumnSection,
    FlexRowSection,
    GreyText,
    SmallHeader,
    SmallText,
    SpanBold
} from "../../../styles/globalStyles";
import {Colors} from "@arboxappv4/shared/src/styles/Colors";
import {useDispatch} from "react-redux";
import {updateModalRes, WAITLIST_DONT_WANT_SLOT_MODAL} from "@arboxappv4/shared/src/redux/modalManagerSlice";
import ConfirmationModal from "../ConfirmationModal";
import useScreenSize from "../../../helpers/hooks/useScreenSize";
import {WAITLIST_DONT_WANT_ACTIONS} from "../../../flowManager/steps/appointmentWaitlist/WaitlistHelpers";

const WaitlistDontWantSlotModal = (props) => {
    const {isOpen, onClose} = props;
    const dispatch = useDispatch();
    const [selected, setSelected] = useState(WAITLIST_DONT_WANT_ACTIONS.SKIP);
    const {isMobile} = useScreenSize();

    const onConfirm = () => {
        dispatch(updateModalRes({modalName: WAITLIST_DONT_WANT_SLOT_MODAL, res: selected}))
        onClose()
    }

    const optionCard = (action, title, description) => {
        const isSelected = selected === action
        const danger = action === WAITLIST_DONT_WANT_ACTIONS.REMOVE
        const dangerSelected = isSelected && danger
        return (
            <ClickableDiv onClick={() => setSelected(action)}>
                <Card flex={'unset'} padding={'16px'} style={{borderColor: dangerSelected ? Colors.siteError : isSelected ? Colors.siteBlack : Colors.siteScheduleBorder}}>
                    <FlexRowSection flex={'unset'} gap={'12px'} align={'start'}>
                        <Radio checked={isSelected} className={dangerSelected ? 'danger-radio-selected' : ''}/>
                        <FlexColumnSection flex={'unset'} gap={'4px'} overflow={'visible'}>
                            <SpanBold fontSize={'18px'} color={dangerSelected ? Colors.siteError : Colors.siteBlack} style={{fontWeight: danger ? 600 : 500}}>{title}</SpanBold>
                            <GreyText fontSize={'16px'} color={dangerSelected ? Colors.siteError : Colors.grey}>{description}</GreyText>
                        </FlexColumnSection>
                    </FlexRowSection>
                </Card>
            </ClickableDiv>
        )
    }

    const content = (
        <FlexColumnSection gap={'20px'} flex={'unset'} overflow={'visible'}>
            <SmallText style={{fontSize: 18}}>{t('appointment-waitlist-offer-dont-want-desc')}</SmallText>
            <FlexColumnSection gap={'16px'} flex={'unset'} overflow={'visible'}>
                {optionCard(WAITLIST_DONT_WANT_ACTIONS.SKIP, t('appointment-waitlist-offer-skip'), t('appointment-waitlist-offer-skip-desc'))}
                {optionCard(WAITLIST_DONT_WANT_ACTIONS.REMOVE, t('appointment-waitlist-offer-remove'), t('appointment-waitlist-offer-remove-desc'))}
            </FlexColumnSection>
        </FlexColumnSection>
    )

    return (
        <ConfirmationModal isOpen={isOpen}
                           onClose={onClose}
                           onConfirm={onConfirm}
                           header={<SmallHeader fontSize={isMobile ? '20px': '18px'}>{t('appointment-waitlist-offer-dont-want-title')}</SmallHeader>}
                           submitText={t('confirm')}
                           content={content}
        />
    );
};

export default WaitlistDontWantSlotModal;
